import React from 'react';
import type { Nullable } from 'corgi-types';

import { HeadlineH8 } from 'common/components/Typography';
import type { ReclamationSolution } from 'common/types/reclamation';
import SectionContainer from './SectionContainer';
import Subtitle from './Subtitle';

export interface SolutionSectionProps {
  solution?: Nullable<ReclamationSolution>;
}

const SolutionSection = ({ solution }: SolutionSectionProps) =>
  solution && (
    <SectionContainer>
      <HeadlineH8 data-testid="solution">{solution.title}</HeadlineH8>
      {solution && !!solution.subTitle && (
        <Subtitle data-testid="solution-notice">{solution.subTitle}</Subtitle>
      )}
    </SectionContainer>
  );

export default SolutionSection;
